import React, { useEffect, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { bulkedCols, taggedCols } from "./mrqFormColumns";
import { Alert, Box, Button, styled } from "@mui/material";
import { addQuotationData } from "./api";
import CommentsBtn from "./CommentsBtn";
import SendIcon from "@mui/icons-material/Send";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { lightTable } from "../../../../styles/muiProps";
import VendorDataSheetModal from "../../../client/AllEquipments/CommonFeatures/MCS3/BOMTab/Components/TrimListDataSheet/VendorDataSheetModal";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const MrqFormTable = ({ data }) => {
  const [input, setInput] = useState([]);
  const [alert, setAlert] = useState("");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);

  useEffect(() => {
    const tableFormatData =
      data?.mrqMaterials?.map((elem) => ({
        mrqMaterialId: elem?.id,
        description: elem?.description,
        remarks: elem?.remarks,
        costCode: elem?.materials[0]?.costCode,
        materials: elem?.materials,
        tagNumber: elem?.materials?.map((m) => m.taggedMaterial?.tagNumber),
        materialCode: elem?.materialCode,
        procuredQty: elem?.procuredQty,
        weight: elem?.weight,
        time: elem?.time,
        cost: elem?.cost,
        submittedDataSheet: elem?.submittedDataSheet,
        procuredUnit: elem?.procuredUnit,
      })) ?? [];

    setInput(tableFormatData);
  }, [data]);

  const handleSaveCell = (cell, value) => {
    input[cell.row.index][cell.column.id] = value;
    setInput([...input]); //re-render with new data
    setSubmitBtnDisabled(false);
  };

  const handleSubmitForm = async () => {
    const vendorData = input.map((m) => {
      return { ...m, mrqId: data.mrqId, vendorId: data.vendorId };
    });

    await addQuotationData({ vendorData })
      .then((res) => {
        console.log({ res });
        setAlert("success");
      })
      .catch((err) => {
        console.log({ err });
        setAlert("error");
      });
  };

  const [currentDataSheet, setCurrentDataSheet] = React.useState({});
  const [openVendorDataSheet, setOpenVendorDataSheet] = React.useState(false);

  const handleOpenVendorDataSheet = () => setOpenVendorDataSheet(true);
  const handleCloseVendorDataSheet = () => setOpenVendorDataSheet(false);

  const onClickRowDataSheet = (row) => {
    setCurrentDataSheet({
      ...row?.material?.specs,
      // ...rawData,
      vendorName: data?.vendorName,
      time: row?.time,
      cost: row?.cost,
      submittedDataSheet: row?.submittedDataSheet,
      row,
    });
    handleOpenVendorDataSheet();
  };

  const onSaveDataSheet = (data) => {
    const updatedInputs = input.map((item) => {
      if (item.mrqMaterialId === data.row?.mrqMaterialId) {
        return {
          ...item,
          submittedDataSheet: data.changes,
        };
      }
      return item;
    });
    setInput(updatedInputs);
    setSubmitBtnDisabled(false);
  };

  const cols =
    data?.mrqMaterials &&
    // data?.mrqMaterials[0]?.materials[0]?.taggedMaterial?.id
    data?.mrqMaterials?.some((row) =>
      row?.materials?.some((material) => material?.tagNumber),
    )
      ? taggedCols(onClickRowDataSheet)
      : bulkedCols(onClickRowDataSheet);

  const table = useMaterialReactTable({
    data: input || [],
    columns: cols,
    ...lightTable,
    enableEditing: true,
    editDisplayMode: "table",
    muiEditTextFieldProps: ({ cell }) => ({
      //onBlur is more efficient, but could use onChange instead
      onBlur: (event) => {
        handleSaveCell(cell, event.target.value);
      },
    }),
    enableBottomToolbar: true,
    renderBottomToolbarCustomActions: () => {
      return (
        <div style={{ width: "100%", "& > div": { p: 0 } }}>
          {alert === "" ? (
            <Box className="no-export" sx={{ textAlign: "right" }}>
              <CommentsBtn data={data} />
              <Button
                variant="contained"
                onClick={handleSubmitForm}
                disabled={submitBtnDisabled}
                endIcon={<SendIcon />}
              >
                Send Quotation
              </Button>

              {/* <Button endIcon={<UploadFileIcon />}>Upload Doc</Button> */}

              <Button
                component="label"
                role={undefined}
                tabIndex={-1}
                endIcon={<UploadFileIcon />}
                sx={{ float: "left" }}
              >
                Upload Document
                <VisuallyHiddenInput
                  type="file"
                  // accept=".pdf"
                  onChange={(event) => console.log(event.target.files)}
                  multiple
                />
              </Button>
            </Box>
          ) : (
            <Alert
              severity={alert}
              sx={{ width: "100%" }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setAlert("");
                  }}
                >
                  Edit
                </Button>
              }
            >
              Thanks, Changes has been saved.
            </Alert>
          )}
        </div>
      );
    },
  });
  return (
    <>
      <MaterialReactTable table={table} />

      <VendorDataSheetModal
        currentDataSheet={currentDataSheet}
        open={openVendorDataSheet}
        onClose={handleCloseVendorDataSheet}
        isVendor={true}
        onSaveDataSheet={onSaveDataSheet}
        submittedDataSheet={currentDataSheet?.submittedDataSheet}
      />
    </>
  );
};

export default MrqFormTable;
